import React from 'react';

function FireTvIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.49 24" width="16" height="22" fill="currentColor">
			<path
				d="M6.2,0H2.3A2.3,2.3,0,0,0,0,2.3H0V21.7A2.3,2.3,0,0,0,2.3,24H6.19a2.3,2.3,0,0,0,2.3-2.3h0V2.3A2.3,2.3,0,0,0,6.2,0ZM4.25,3a.58.58,0,0,1,.59.58.59.59,0,0,1-.59.58A.58.58,0,0,1,4.25,3Zm0,3.08A2.18,2.18,0,1,1,2.08,8.29,2.17,2.17,0,0,1,4.25,6.11Zm-2,8.41a.58.58,0,0,1-.58-.58.57.57,0,0,1,.58-.58.58.58,0,0,1,.59.58.59.59,0,0,1-.59.58Zm2-1.16a.58.58,0,0,1,.59.58.59.59,0,0,1-.59.58.58.58,0,0,1,0-1.16Zm.59,7a.59.59,0,1,1-1.17,0V16.74a.59.59,0,0,1,1.17,0Zm1.41-5.87a.58.58,0,0,1-.58-.58.57.57,0,0,1,.58-.58.58.58,0,0,1,.59.58.59.59,0,0,1-.59.58Z"/>
		</svg>
	);
}

export default FireTvIcon;